import React from 'react'
import { Grid, Skeleton } from '@mui/material'
type ShopSkeletonType = 'category' | 'product' | 'history'

const SkeletonType: Record<ShopSkeletonType, number> = {
  category: 6,
  product: 2,
  history: 12,
}

export const ShopMainSkeleton: React.VFC<{ shopSkeletonType?: ShopSkeletonType }> = ({ shopSkeletonType }) => {
  const gridSize = SkeletonType[shopSkeletonType || 'product']

  return (
    <Grid container spacing={3}>
      <Grid item xs={gridSize}>
        <Skeleton variant="rectangular" height="300px"></Skeleton>
      </Grid>
      <Grid item xs={gridSize}>
        <Skeleton variant="rectangular" height="300px"></Skeleton>
      </Grid>
      <Grid item xs={gridSize}>
        <Skeleton variant="rectangular" height="300px"></Skeleton>
      </Grid>
      <Grid item xs={gridSize}>
        <Skeleton variant="rectangular" height="300px"></Skeleton>
      </Grid>
      <Grid item xs={gridSize}>
        <Skeleton variant="rectangular" height="300px"></Skeleton>
      </Grid>
      <Grid item xs={gridSize}>
        <Skeleton variant="rectangular" height="300px"></Skeleton>
      </Grid>
    </Grid>
  )
}
